import React from 'react';
import { Header } from './components/header/header';
import { Main } from './modules/main';

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Rules } from './modules/rules';

function App() {
  return (
    <BrowserRouter >
      <div className="App">
        <Header/>
          <Routes >
            <Route Component={Main} path='/'/>
            <Route Component={Rules} path='/rules'/>
          </Routes>  
      </div>
    </BrowserRouter>
  );
}

export default App;
